import { render, staticRenderFns } from "./kaiTingGongGao.vue?vue&type=template&id=33b72cdb&scoped=true&"
import script from "./kaiTingGongGao.vue?vue&type=script&lang=js&"
export * from "./kaiTingGongGao.vue?vue&type=script&lang=js&"
import style0 from "./kaiTingGongGao.vue?vue&type=style&index=0&id=33b72cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b72cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b72cdb')) {
      api.createRecord('33b72cdb', component.options)
    } else {
      api.reload('33b72cdb', component.options)
    }
    module.hot.accept("./kaiTingGongGao.vue?vue&type=template&id=33b72cdb&scoped=true&", function () {
      api.rerender('33b72cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/kaiTingGongGao.vue"
export default component.exports